import Vue from 'vue'
import axios from 'axios'
import Vueaxios from 'vue-axios'
import qs from 'qs'
import _config from 'config'
import userSessionUtils from '@/common/userSessionUtils'
Vue.use(Vueaxios, axios)

let sources = {}

const Axios = axios.create({
	timeout: 60000,
	responseType: 'json',
	withCredentials: true,
	headers: {
		// 'Content-Type': 'application/x-www-form-urlencoded'
	}
})

const codeMessage = {
	200: '服务器成功返回请求的数据。',
	201: '新建或修改数据成功。',
	202: '一个请求已经进入后台排队（异步任务）。',
	204: '删除数据成功。',
	400: '发出的请求有错误，服务器没有进行新建或修改数据的操作。',
	401: '用户没有权限（令牌、用户名、密码错误）。',
	403: '用户得到授权，但是访问是被禁止的。',
	404: '发出的请求针对的是不存在的记录，服务器没有进行操作。',
	406: '请求的格式不可得。',
	410: '请求的资源被永久删除，且不会再得到的。',
	422: '当创建一个对象时，发生一个验证错误。',
	500: '服务器发生错误，请检查服务器。',
	502: '网关错误。',
	503: '服务不可用，服务器暂时过载或维护。',
	504: '网关超时。',
};

Axios.interceptors.request.use(
	config => {
		let token = []
		let url
		if (config.method == 'post') {
			url = config.url + config.data
		} else if (config.method == 'get') {
			url = config.url;
		}
		config.cancelToken = new axios.CancelToken(cancel => sources[url] = {
			cancel
		});
		// const client_id = sessionStorage.getItem('client_id')
		const filterfx = sessionStorage.getItem('filterfx')
		// if (client_id != null) {
		// 	token.client_id = client_id
		// }
		if (filterfx != null) {
			token.filterfx = filterfx
		}
		config.params = {
			...token,
			...config.params
		}
		return config
	},
	error => {
		console.log('网络异常')
		return Promise.reject(error)
	}
)

Axios.interceptors.response.use(
	response => {
		return response
	},
	error => {
		console.log(error)
		if (error && error.response) {
			const status = error.response.status;
			const errortext = codeMessage[status] || error.response.statusText;
			let alertTips = errortext
			Vue.$alert.show({
				title: '请求错误 ${status}',
				content: alertTips,
				onConfirm() { }
			})
		}
		return Promise.reject(error)
	}
)

export function fetch(params = {},options={}) {
	const client_id = sessionStorage.getItem('client_id')
	if (client_id != null) {
		params.client_id = client_id
	}
	let apiUrl = options.apiUrl?options.apiUrl:_config.apiUrl
	return new Promise((resolve, reject) => {
		Axios.get(apiUrl, {
			params: params,
			withCredentials: options.hasOwnProperty('withCredentials')?options.withCredentials:true
		})
			.then(response => {
				let results = response.data;
				if (-79999999 == results.error_no) {
					Vue.$alert.show({
						title: '提示',
						content: response.error_info,
						confirmText: '我知道了',
						onConfirm() {
							userSessionUtils.filterLoginOut()
						}
					})
				} else if (-999 == results.error_no || -10000 == results.error_no) {
					userSessionUtils.filterLoginOut()
				} else {
					resolve(results)
				}
			})
			.catch(err => {
				if (axios.isCancel(err)) {
					console.log('Request canceled', err.message);
				} else {
					console.log(err);
				}
			})
	})
}

export function post(params = {}) {
	const client_id = sessionStorage.getItem('client_id')
	if (client_id != null) {
		params.client_id = client_id
	}
	return new Promise((resolve, reject) => {
		Axios.post(_config.apiUrl, qs.stringify(params), {
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded'
			}
		}).then(
			response => {
				let results = response.data;
				if (-79999999 == results.error_no) {
					Vue.$alert.show({
						title: '提示',
						content: response.error_info,
						confirmText: '我知道了',
						onConfirm() {
							userSessionUtils.filterLoginOut()
						}
					})
				} else if (-999 == results.error_no || -10000 == results.error_no) {
					userSessionUtils.filterLoginOut()
				} else {
					resolve(results)
				}
			},
			err => {
				if (axios.isCancel(err)) {
					console.log('Request canceled', err.message);
				} else {
					console.log(err);
				}
			}
		)
	})
}

export {
	sources
}



// WEBPACK FOOTER //
// ./src/utils/api.js